const TYPES = ['bar', 'donut', 'line', 'area'];

/** Models reach for pie by name; it is the same chart. */
const ALIASES = {
  pie: 'donut',
  doughnut: 'donut',
  column: 'bar'
};
const toType = raw => {
  var _ALIASES$name;
  const name = String(raw !== null && raw !== void 0 ? raw : '').toLowerCase();
  if (TYPES.includes(name)) return name;
  return (_ALIASES$name = ALIASES[name]) !== null && _ALIASES$name !== void 0 ? _ALIASES$name : null;
};

/**
 * The prompt pins a flat [{label, value}] contract, but a model that has seen a million Chart.js
 * configs will sometimes answer with {labels, datasets} anyway. Accepting both is cheaper than a
 * chart that silently renders as raw JSON in the middle of a reply, which is exactly what it did.
 */
const toPoints = data => {
  if (Array.isArray(data)) {
    return data.filter(d => typeof d === 'object' && d !== null && typeof d.label === 'string' && Number.isFinite(d.value));
  }
  if (typeof data === 'object' && data !== null) {
    var _datasets$;
    const _ref = data,
      labels = _ref.labels,
      datasets = _ref.datasets;
    const values = Array.isArray(datasets) ? (_datasets$ = datasets[0]) === null || _datasets$ === void 0 ? void 0 : _datasets$.data : undefined;
    if (Array.isArray(labels) && Array.isArray(values)) {
      return labels.map((label, i) => ({
        label: String(label),
        value: Number(values[i])
      })).filter(p => Number.isFinite(p.value));
    }
  }
  return [];
};

/**
 * Pulls a fenced ```chart block out of a reply.
 *
 * Also tolerates a bare `chart\n{...}` line: a prompt pipeline that strips backticks turns the
 * fence into a plain keyword, and the chart silently stops rendering. Cheap to absorb here.
 */
function parseSpec(raw) {
  let parsed;
  try {
    parsed = JSON.parse(raw.trim());
  } catch (_unused) {
    return null;
  }
  if (typeof parsed !== 'object' || parsed === null) return null;
  const _ref2 = parsed,
    type = _ref2.type,
    title = _ref2.title,
    unit = _ref2.unit,
    data = _ref2.data,
    reference = _ref2.reference;
  const chartType = toType(type);
  if (!chartType) return null;

  // 24: the longest range a report covers, so a two-year trend is not cut off.
  const points = toPoints(data).slice(0, 24);
  if (points.length === 0) return null;
  return {
    type: chartType,
    title: typeof title === 'string' ? title : undefined,
    unit: typeof unit === 'string' ? unit : undefined,
    reference: typeof reference === 'number' && Number.isFinite(reference) ? reference : undefined,
    data: points
  };
}
export function extractChart(content) {
  // A reply can carry more than one chart. Pulling only the first left the rest rendered as raw
  // JSON in the middle of the answer, which is how this was found.
  const blocks = [...content.matchAll(/```chart\s*([\s\S]*?)```/g), ...content.matchAll(/```(?:json)?\s*(\{\s*"type"\s*:\s*"(?:bar|line|donut|pie|doughnut)"[\s\S]*?\})\s*```/g), ...content.matchAll(/^chart\s*(\{[\s\S]*?\})\s*$/gm)];
  let body = content;
  const charts = [];
  for (const match of blocks) {
    const chart = parseSpec(match[1]);
    if (!chart) continue; // a malformed spec stays visible rather than being silently blanked
    charts.push(chart);
    body = body.replace(match[0], '');
  }
  // Lifting blocks out leaves the blank lines that surrounded them, which reads as a hole.
  return {
    body: body.replace(/\n{3,}/g, '\n\n').trim(),
    charts
  };
}